export enum ComponentShape {
  ROUND = 'round',
  SEMI_ROUND = 'semi-round',
  SQUARE = 'square',
}
